export const AUTH_STORAGE_KEY = 'auth-storage'
export const GENERAL_SETTINGS_STORAGE_KEY = 'general-settings-storage'
export const SEARCH_SECTION_STORAGE_KEY = 'search-section-storage'
export const GROUPED_FILTER_SECTION_STORAGE_KEY = 'grouped-filter-section-storage'
